import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Box, Container, Typography, Grid, InputAdornment, TextField } from "@mui/material";
import Search from "@mui/icons-material/Search";

import OrgChartComponent from "../../../components/OrgChart";
import { getOrganization } from "../../../actions/organization";
import * as Util from "../../../services/global.service";


const useStyles = makeStyles({
  boxActive: {},
});
const styles = {
  container: {
    maxHeight: "100vh",
    border: "1px solid red",
  },
};

const Organization = () => {
  const { t, i18n } = useTranslation();
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    dispatch(getOrganization()).then((resp) => {
      if (resp && resp.length > 0) {
        let formatData = resp.map((item) => {
          // cal diff level
          let jsonItemOptions = JSON.parse(item.options)
          let diffLevel = 0
          if (item.organizationParent !== 0) {
            let parentNode = resp.filter(v => v.id === item.organizationParent)
            // console.log("parentNode", parentNode)
            // console.log("node", parentNode, item.organizationParent)
            let jsonParentOptions = parentNode[0]?.options ? JSON.parse(parentNode[0]?.options) : { level: null }
            let parentLevel = jsonParentOptions?.level ? parseInt(jsonParentOptions.level) : 1
            let itemLevel = jsonItemOptions.level ? parseInt(jsonItemOptions.level) : 1
            diffLevel = Math.abs(itemLevel - parentLevel)
            // console.log(item.nameEn, parentLevel, itemLevel, diffLevel)
          }
          return {
            id: item.id,
            pid: item.organizationParent,
            nameEn: item.nameEn ? item.nameEn : "-",
            nameTh: item.nameTh ? item.nameTh : "-",
            code: item.code ? item.code : "-",
            level: item.level,
            tags: [`level${diffLevel ? diffLevel - 1 : diffLevel}`],
            img: `/orgchart/lv${jsonItemOptions.level ? jsonItemOptions.level : 1}.svg`,
            acronymEn: item.acronymEn ? item.acronymEn : "-",
            acronymTh: item.acronymTh ? item.acronymTh : "-",
            dataAsOf: new Date(item.dataAsOf).toLocaleString(
              i18n.language === "th-TH" ? "th-TH" : "en-GB",
              {
                year: "2-digit",
                month: "short",
                day: "numeric",
              }
            )
          };
        });
        setData(formatData);
      }
    });
  }, []);

  useEffect(() => {
    let result = [];
    const delayDebounceFn = setTimeout(() => {
      if (search !== "") {
        result = [...data].filter((item) => {
          return ((item.nameEn?.toString().toLowerCase().indexOf(search) !== -1 ?? false) || (item.nameTh?.toString().toLowerCase().indexOf(search) !== -1 ?? false) || (item.code?.toString().toLowerCase().indexOf(search) !== -1 ?? false))
        })
      } else {
        result = [];
      }
      setFilteredData(result)
    }, 1000)
    return () => clearTimeout(delayDebounceFn)
  }, [search])

  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  return (
    <>
      <Helmet>
        <title>Organization Chart | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          pt: 3,
          position: 'relative'
        }}
      >
        <Container maxWidth={false} p={0} sx={{ position: 'relative' }}>
          <Grid container pt={2} pb="30px">
            <Grid item>
              <Typography variant="h1" fontSize={36} color="#404349" lineHeight="39.6px" fontWeight="600">
                <span style={styles.link} onClick={() => { }}>
                  {t("label.organizationChart")}
                </span>
              </Typography>
            </Grid>
            <Grid item ml="auto">
              <TextField
                fullWidth
                id="input-with-icon-textfield"
                placeholder={t("label.search")}
                size="small"
                sx={{ background: "#fff", height: "40px" }}
                className="searchTextField-h48"
                value={search}
                onChange={handleSearch}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search style={{ color: "#C4C4C4" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
          <OrgChartComponent
            nodes={data}
            searchNodes={filteredData}
          />
        </Container>
      </Box>
    </>
  );
};
export default Organization;
